import { createContext, useContext } from "react"
import type { AppPlatform, AppPlatformProviderProps } from "./types"

const PlatformContext = createContext<AppPlatform | undefined>(undefined)

export const PlatformProvider = ({
	children,
	platform,
}: AppPlatformProviderProps) => (
	<PlatformContext.Provider value={platform}>
		{children}
	</PlatformContext.Provider>
)

export const usePlatform = () => {
	const platform = useContext(PlatformContext)
	if (!platform) {
		throw new Error("usePlatform must be used within a PlatformProvider")
	}
	return platform
}
